module.exports = __webpack_public_path__ + "img/CZE.37a9473e.png";